var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "profile-form" } },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-cogs",
            backPath: "/configurations/profiles",
          },
        },
        [_c("h1", { domProps: { innerHTML: _vm._s(_vm.pageTitle) } })]
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-4 col-xl-3" },
            [
              _c("UiCard", [
                _c(
                  "div",
                  [
                    _c(
                      "FormWrapper",
                      [
                        _vm.isEditRoute &&
                        _vm.$route.params.id &&
                        _vm.nbAppliedDevices < _vm.countDatis
                          ? _c("div", {
                              staticClass: "alert alert-warning",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("profile.warningVisibility", {
                                    count:
                                      _vm.countDatis - _vm.nbAppliedDevices,
                                  })
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "FormControl",
                          [
                            _c("FormLabel", [
                              _vm._v(_vm._s(_vm.$t("profile.form.icon"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "FormElement",
                              [
                                _c("IconPicker", {
                                  attrs: { icon: _vm.profileDef.meta.icon },
                                  on: { change: _vm.selectIcon },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "FormControl",
                          [
                            _c("FormLabel", [
                              _vm._v(_vm._s(_vm.$t("profile.form.label"))),
                            ]),
                            _vm._v(" "),
                            _c("UiInput", {
                              staticClass: "form-input",
                              attrs: {
                                name: "label",
                                isInvalid: _vm.$v.profileDef.meta.$invalid,
                                maxlength: 64,
                              },
                              model: {
                                value: _vm.profileDef.meta.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.profileDef.meta, "name", $$v)
                                },
                                expression: "profileDef.meta.name",
                              },
                            }),
                            _vm._v(" "),
                            _vm.$v.profileDef.meta.$invalid
                              ? _c("FormError", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("validation.required_field")
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "FormControl",
                          [
                            _c("FormLabel", [
                              _vm._v(
                                _vm._s(_vm.$t("profile.form.description"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("UiTextarea", {
                              attrs: { name: "description" },
                              model: {
                                value: _vm.profileDef.meta.description,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.profileDef.meta,
                                    "description",
                                    $$v
                                  )
                                },
                                expression: "profileDef.meta.description",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "FormControl",
                          [
                            _c("FormLabel", [
                              _vm._v(
                                _vm._s(_vm.$t("profile.form.set_as_default"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("FormElement", [
                              _c(
                                "div",
                                {
                                  staticClass: "star-check",
                                  attrs: {
                                    title: _vm.$t(
                                      "profile.form.set_as_default"
                                    ),
                                  },
                                  on: { click: _vm.handleDefaultStar },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.profileDef.meta.default,
                                        expression: "profileDef.meta.default",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.profileDef.meta.default
                                      )
                                        ? _vm._i(
                                            _vm.profileDef.meta.default,
                                            null
                                          ) > -1
                                        : _vm.profileDef.meta.default,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a = _vm.profileDef.meta.default,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.profileDef.meta,
                                                "default",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.profileDef.meta,
                                                "default",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.profileDef.meta,
                                            "default",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "fa fa-star-o" }),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "fa fa-star" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "focus-block" }),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("ProfilesIndicator", {
                      staticClass: "mt-5",
                      attrs: {
                        perf: _vm.perf,
                        nbDatis: _vm.nbDatis,
                        datisLicences: _vm.datisLicences,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-8 col-xl-9" },
            [
              _c(
                "UiCard",
                [
                  !_vm.profileDef.userCanUpdate
                    ? _c("div", { staticClass: "alert alert-warning mb-3" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "profile.errors.user_has_no_dati_visibility"
                              )
                            ) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "UiTabs",
                    {
                      staticClass: "full-height mt-1",
                      staticStyle: {
                        display: "grid",
                        "grid-template-rows": "min-content 1fr",
                      },
                      attrs: {
                        "content-class": "full-height overflow-auto py-5",
                      },
                    },
                    [
                      _c(
                        "UiTab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("profile.form.tab_workers")
                                      ) +
                                      " (" +
                                      _vm._s(_vm.nbDatis) +
                                      ")\n                            "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "container" },
                            [
                              _c(
                                "FormWrapper",
                                [
                                  _vm._l(
                                    _vm.servers,
                                    function (tag, key, indexTag) {
                                      return _vm.userHasOffer(tag.offers)
                                        ? _c(
                                            "FormControl",
                                            { key: "tag" },
                                            [
                                              _c("FormLabel", [
                                                tag.type == "relation" &&
                                                key == "telesurveilleur"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          position: "relative",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-exclamation-triangle text-warning warning-beepiz-remote-monitoring",
                                                          class: {
                                                            show: _vm.showWarningBeepizRemoteMonitoring,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltip left",
                                                            staticStyle: {
                                                              width: "250px",
                                                              top: "-2px",
                                                              left: "37px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "profile.tooltipWarningBeepizRemoteMonitoring"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                key == "sms" || key == "vocal"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          position: "relative",
                                                          "margin-left": "10px",
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-question-circle text-warning warning-beepiz-remote-monitoring show",
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "tooltip left",
                                                            staticStyle: {
                                                              width: "250px",
                                                              top: "-2px",
                                                              left: "37px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "profile.tooltipWarningPhoneNumber"
                                                                  )
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                            key == "vocal"
                                                              ? [
                                                                  _c("br"),
                                                                  _c("br"),
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "profile.tooltipCaller"
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "FormElement",
                                                [
                                                  tag.type === "array"
                                                    ? _c("multiselect", {
                                                        staticClass:
                                                          "form-input no-select",
                                                        attrs: {
                                                          id: key,
                                                          multiple: true,
                                                          "close-on-select": true,
                                                          taggable: true,
                                                          placeholder: "",
                                                          options: [],
                                                          label: "label",
                                                          "track-by": "key",
                                                        },
                                                        on: {
                                                          tag: _vm.addItem,
                                                          blur: _vm.handleBlur,
                                                        },
                                                        model: {
                                                          value: tag.value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              tag,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tag.value",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  tag.type === "boolean"
                                                    ? _c("UiSwitch", {
                                                        attrs: {
                                                          "true-value": 1,
                                                          "false-value": 0,
                                                        },
                                                        model: {
                                                          value: tag.value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              tag,
                                                              "value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "tag.value",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  tag.type === "relation"
                                                    ? _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value: tag.value,
                                                              expression:
                                                                "tag.value",
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-input col",
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$selectedVal =
                                                                Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      var val =
                                                                        "_value" in
                                                                        o
                                                                          ? o._value
                                                                          : o.value
                                                                      return val
                                                                    }
                                                                  )
                                                              _vm.$set(
                                                                tag,
                                                                "value",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                          },
                                                        },
                                                        _vm._l(
                                                          tag.values,
                                                          function (
                                                            val,
                                                            keyVal
                                                          ) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key: val.id,
                                                                domProps: {
                                                                  value: val.id,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.constructLabelByKey(
                                                                        key,
                                                                        val
                                                                      )
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "FormControl",
                                    {
                                      directives: [
                                        {
                                          name: "can",
                                          rawName: "v-can",
                                          value: "beepiz-select-devices",
                                          expression: "'beepiz-select-devices'",
                                        },
                                      ],
                                    },
                                    [
                                      _c(
                                        "FormLabel",
                                        { staticClass: "sr-only" },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$t(
                                                  "profile.form.assocDevices"
                                                )
                                              ) +
                                              "\n                                            "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "badge ml-1" },
                                            [_vm._v(_vm._s(_vm.nbDatis))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "FormElement",
                                        { staticClass: "w-100" },
                                        [
                                          !_vm.allDatis
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "spinner-border text-secondary",
                                                  attrs: { role: "status" },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sr-only" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "global.loading"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.allDatis
                                            ? _c("SelectList", {
                                                attrs: {
                                                  list: _vm.allDatis,
                                                  itemType: "dati",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "UiTab",
                        { attrs: { title: _vm.$t("profile.form.tab_watchs") } },
                        [
                          _c(
                            "div",
                            { staticClass: "container-fluid" },
                            [
                              _c("div", {
                                staticClass: "alert alert-info mb-4",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("watches.helper_text")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("WatchesForm", {
                                attrs: { datisLicences: _vm.datisLicences },
                                model: {
                                  value: _vm.profileDef.watch,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.profileDef, "watch", $$v)
                                  },
                                  expression: "profileDef.watch",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "UiTab",
                        { attrs: { title: _vm.$t("profile.form.tab_alerts") } },
                        [
                          _c(
                            "div",
                            { staticClass: "container" },
                            [
                              _c("FilterField", {
                                staticClass: "mb-5",
                                on: { filter: _vm.onFilter },
                              }),
                              _vm._v(" "),
                              _c("Config", {
                                attrs: {
                                  config: _vm.profileDef.config,
                                  filterStr: _vm.filterStr,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "Toolbar",
        [
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-profiles",
                  expression: "'beepiz-edit-profiles'",
                },
              ],
              staticClass: "primary pull-right",
              attrs: {
                disabled: _vm.$v.$invalid || !_vm.profileDef.userCanUpdate,
              },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.postData()
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("global.save")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "profiles.profiles.edit",
                  expression: "'profiles.profiles.edit'",
                },
              ],
              class: "pull-right",
            },
            [
              _c(
                "router-link",
                { attrs: { to: "/configurations/profiles", tag: "span" } },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }